// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "client-viewer/" + {"2805":"audio","2999":"giphy","5009":"image","7509":"linkPreview","9239":"poll"}[chunkId] + ".chunk.min.css";
};